import React from 'react';

const CreditsIcon = ({ size = 20, color = 'currentColor', className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
      color={color}
    >
      <path
        d="M15.8206 1.36075C15.7973 1.15542 15.6237 1.00021 15.4171 1C15.2104 0.999789 15.0365 1.15464 15.0128 1.35993C14.865 2.64161 14.1416 3.36501 12.8599 3.51284C12.6546 3.53652 12.4998 3.71044 12.5 3.91708C12.5002 4.12373 12.6554 4.29733 12.8608 4.32059C14.1243 4.4637 14.8978 5.18014 15.0118 6.4628C15.0304 6.67271 15.2064 6.83357 15.4171 6.83333C15.6279 6.8331 15.8035 6.67184 15.8217 6.46189C15.9311 5.19736 16.6974 4.43112 17.9619 4.32166C18.1718 4.30348 18.3331 4.12787 18.3333 3.91712C18.3336 3.70638 18.1727 3.5304 17.9628 3.51176C16.6801 3.39782 15.9637 2.62425 15.8206 1.36075Z"
        fill="currentColor"
      />
      <path
        d="M13.8462 13.8092C13.8263 13.6332 13.6775 13.5002 13.5004 13.5C13.3232 13.4998 13.1742 13.6326 13.1539 13.8085C13.0272 14.9071 12.4071 15.5272 11.3085 15.6539C11.1326 15.6742 10.9998 15.8232 11 16.0004C11.0002 16.1775 11.1332 16.3263 11.3092 16.3462C12.3922 16.4689 13.0553 17.083 13.1529 18.1824C13.1689 18.3623 13.3198 18.5002 13.5004 18.5C13.681 18.4998 13.8316 18.3616 13.8471 18.1816C13.941 17.0977 14.5977 16.441 15.6816 16.3471C15.8616 16.3316 15.9998 16.181 16 16.0004C16.0002 15.8198 15.8623 15.6689 15.6824 15.6529C14.583 15.5553 13.9689 14.8922 13.8462 13.8092Z"
        fill="currentColor"
      />
      <path
        d="M7.50013 4C7.52445 7.24324 10.2568 9.98287 13.5 9.99994C10.2568 9.99994 7.52445 12.7568 7.50013 16C7.4758 12.7568 4.74324 9.99994 1.5 9.99994C4.74324 9.99994 7.4758 7.24324 7.50013 4Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CreditsIcon;


